<template>
  <h3 class="detail-title-lv1">
    {{ title }}
  </h3>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
